import { render, staticRenderFns } from "./BulkReturnStatusModal.vue?vue&type=template&id=1c552d1c&scoped=true&"
import script from "./BulkReturnStatusModal.vue?vue&type=script&lang=js&"
export * from "./BulkReturnStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./BulkReturnStatusModal.vue?vue&type=style&index=0&id=1c552d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c552d1c",
  null
  
)

export default component.exports